import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Undo.svg",
  "use": "Undo.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Undo.svg\"><path d=\"M34.0208,52.0208h-16a2,2,0,1,1,0-4h16a14,14,0,1,0,0-28H24.0316V25.016a1.0245,1.0245,0,0,1-1.6182.8191l-9.9482-6.9889a.9969.9969,0,0,1,0-1.638l9.9482-6.9889a1.0245,1.0245,0,0,1,1.6182.8191v4.9825h9.9892a18,18,0,0,1,0,36Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol